module.exports = __webpack_public_path__ + "img/fzwl.78c6a05d.jpg";